import React from 'react';
import { useTranslation } from 'react-i18next';
import { DeepMap, FieldError, FieldValues } from 'react-hook-form';
import ErrorMessageWrapper from '../ErrorMessageWrapper';

interface PropTypes {
  errors: DeepMap<FieldValues, FieldError>;
  errorMessage?: string;
}

const ErrorMessage: React.FC<PropTypes> = ({ errors, errorMessage }) => {
  const { t } = useTranslation(['forgotPassword', 'formError']);

  return (
    <ErrorMessageWrapper>
      {(() => {
        if (errors.id && errors.id.type === 'required') {
          return (
            <>
              {t('forgotPassword:id')}
              {t('formError:required')}
            </>
          );
        }
        if (errors.id && errors.id.type === 'pattern') {
          return (
            <>
              {t('forgotPassword:id')}
              {t('formError:charTypeCheck', {
                charType: t('formError:mailType'),
              })}
            </>
          );
        }
        if (errorMessage) {
          return <>{errorMessage}</>;
        }
        return <></>;
      })()}
    </ErrorMessageWrapper>
  );
};

export default ErrorMessage;
